import { KnownError } from './knownError';

export class UnexpectedApiResponseError extends KnownError {
  constructor() {
    super('An external API responded with unexpected response data');
    this.name = 'UnexpectedApiResponseError';
  }
}
